import { MutableRefObject, PropsWithChildren, JSX, useRef, ElementRef } from 'react';
import classNames from 'classnames';
import { useRipple } from '@bg-shared';
import classes from './NavigationItem.module.scss';

interface IProps {
    active: boolean;
    onClick(ref: MutableRefObject<HTMLButtonElement>): void;
    dataQa?: string;
    secondaryTheme?: boolean;
    className?: string;
    id?: string;
}

export const NavigationItem = (props: PropsWithChildren<IProps>): JSX.Element => {
    const ripple = useRipple();
    const buttonRef = useRef<ElementRef<'button'>>();
    const classNameSuffix = props.secondaryTheme ? 'Secondary' : '';

    return (
        <button
            ref={buttonRef}
            id={props.id}
            type="button"
            onClick={() => {
                props.onClick(buttonRef);
            }}
            className={classNames(
                classes.item,
                props.className,
                ripple.className,
                classes[`hover${classNameSuffix}`],
                {
                    [classes[`active${classNameSuffix}`]]: props.active,
                },
            )}
            data-qa={props.dataQa}
            onMouseDown={ripple.start}
        >
            {props.children}
        </button>
    );
};
